app.service('permissionsHelper', ['authHelper', function (authHelper) {
  const permissionsHelper= this;

  permissionsHelper.hasPermission = function (permission) {
    // Nothing is permitted until we know who the user is. Treating "not known
    // yet" as "not an admin" fell through to the blanket allow below, so on
    // every page load -- most visibly a refresh, which drops the cached session
    // details -- admin users were briefly granted every permission and saw menu
    // items, dashboard tiles and buttons their role does not allow (RPR-6816).
    // This supersedes the RPR-5307 guard in authHelper.getUserPermissions, which
    // could never fire: the blanket allow returned first.
    if (!authHelper.areUserDetailsLoaded()) {
      return false;
    }

    // For payer and client user return true, as no need to check permissions
    // for them. Permissions are only for admin users.
    if (!authHelper.isUserAdmin()) {
      return true;
    }

    const permissions = authHelper.getUserPermissions();
    if (permissions) {
      return permissions.includes(permission);
    } else {
      return false;
    }
  };

  permissionsHelper.hasAnyOfPermissions = function (permissions_list) {
    for (const permission of permissions_list) {
      if (permissionsHelper.hasPermission(permission)) {
        return true;
      }
    }
    return false;
  };

  permissionsHelper.hasAllOfPermissions = function (permissions_list) {
    for (const permission of permissions_list) {
      if (!permissionsHelper.hasPermission(permission)) {
        return false;
      }
    }
    return true;
  };

  permissionsHelper.hasCreateOrUpdatePermission = function (is_create_request, create_permission, update_permission) {
    // A utility function to check if the user has permission to create or update.
    // If it is a create request, then check for create permission. Otherwise, check for update permission.
    return (
      (is_create_request && permissionsHelper.hasPermission(create_permission)) ||
        (!is_create_request && permissionsHelper.hasPermission(update_permission))
    );
  };
}]);
